import { render, staticRenderFns } from "./UserQualificationForm.vue?vue&type=template&id=53d065c1&scoped=true"
import script from "./UserQualificationForm.vue?vue&type=script&lang=js"
export * from "./UserQualificationForm.vue?vue&type=script&lang=js"
import style0 from "./UserQualificationForm.vue?vue&type=style&index=0&id=53d065c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d065c1",
  null
  
)

export default component.exports